import { AbstractControl } from '@angular/forms';
import { of, OperatorFunction, pipe } from 'rxjs';
import { distinctUntilChanged, map, skip, startWith, switchMap } from 'rxjs/operators';

export function controlInvalid(): OperatorFunction<AbstractControl | null | undefined, boolean> {
  return pipe(
    switchMap(
      (control: AbstractControl | null | undefined) =>
        control?.statusChanges.pipe(
          map(() => control.invalid),
          startWith(control.invalid)
        ) ?? of(false)
    ),
    distinctUntilChanged()
  );
}

export function controlInvalidChanges(): OperatorFunction<
  AbstractControl | null | undefined,
  boolean
> {
  return pipe(controlInvalid(), skip(1));
}
